import React from 'react';
import { Light as SyntaxHighlighter } from 'react-syntax-highlighter';
import js from 'react-syntax-highlighter/dist/esm/languages/hljs/javascript';
import { docco, dark } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import { Paper, Typography, Box, Button, useTheme, useMediaQuery } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { config_strings } from './config/config';

SyntaxHighlighter.registerLanguage('javascript', js);

const IntroSection = () => {
  const theme = useTheme();
  
  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: theme.palette.primary.main }}>
        { config_strings.intros.integrations.title }
      </Typography>
      <Typography variant="body1" sx={{ fontSize: '0.9rem', lineHeight: 1.6 }}>
        { config_strings.intros.integrations.text }
      </Typography>
    </Box>
  );
};

const CodeSnippet = ({ code }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isDarkMode = theme.palette.mode === 'dark';

  const handleCopy = () => {
    navigator.clipboard.writeText(code);
    // Optionally, add a notification here
  };

  return (
    <Paper 
      elevation={3} 
      sx={{ 
        p: { xs: 1, sm: 2 }, 
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        width: '100%',
        mx: 'auto',
        border: `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)'}`,
      }}
    >
      <IntroSection />
      <Box sx={{ position: 'relative' }}>
        <Box sx={{ overflow: 'auto', maxWidth: '100%' }}>
          <SyntaxHighlighter 
            language="javascript" 
            style={isDarkMode ? dark : docco}
            customStyle={{
              padding: '1em',
              borderRadius: '4px',
              fontSize: isMobile ? '0.7rem' : '0.9rem',
              lineHeight: 1.5,
              backgroundColor: isDarkMode ? theme.palette.background.default : theme.palette.background.paper,
            }}
            wrapLongLines={true}
            showLineNumbers={!isMobile}
          >
            {code}
          </SyntaxHighlighter>
        </Box>
        <Button
          variant="contained"
          startIcon={<ContentCopyIcon />}
          onClick={handleCopy}
          size={isMobile ? "small" : "medium"}
          sx={{
            position: 'absolute',
            top: '8px',
            right: '8px',
            zIndex: 1,
            fontSize: isMobile ? '0.7rem' : '0.875rem',
          }}
        >
          Copy
        </Button>
      </Box>
    </Paper>
  );
};

export default CodeSnippet;